import { Provider } from "react-redux";
import store from "./redux/store";
import Router from "./router";
import Mui from "./styles/Mui";
import "./config/firebaseConfig";
import Notification from "./layout/Notification";
import PopupMessage from "./components/popups/PopupMessage";
import LoaderFeedback from "./layout/loader/LoaderFeedback";
import MetaTags from "./layout/MetaTags";
import NoInternet from "./components/NoInternet";

function App() {
  return (
    <Provider store={store}>
      <MetaTags />
      <Mui>
        <Router />
        <Notification />
        <PopupMessage />
        <LoaderFeedback />
        <NoInternet />
      </Mui>
    </Provider>
  );
}

export default App;
